/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  dummy: 'dummy_c19165f4',
};

export = styles;

loadStyles([{"rawString":".dummy_c19165f4{background:#00f}"}]);
/* tslint:enable */